import { useEffect } from "react";
import { useRouter } from "next/router";
import {
  Autocomplete,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useReportStore } from "@/stores/reportStore";

export const TrainingOrgRptAutocomplete = () => {
  const {
    trainingOrganizations,
    fetchTrainingOrganizations,
    selectedTrainingOrganization,
    setSelectedTrainingOrganization,
    setSelectedOrganization
  } = useReportStore();
  const router = useRouter();

  const theme = useTheme();
  const isViewportMediumOrLarger = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    fetchTrainingOrganizations();
  }, [fetchTrainingOrganizations]);

  return (
    <Autocomplete
      id={"training-org-autocomplete"}
      getOptionLabel={(option) => option.name}
      options={trainingOrganizations}
      value={selectedTrainingOrganization}
      onChange={(_, newValue) => {
        setSelectedTrainingOrganization(newValue);
        setSelectedOrganization(null);
        // router.push(`/eventManagement/${newValue.id}/events`);
      }}
      fullWidth
      clearIcon={null}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={"Select Training Org."}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            sx: isViewportMediumOrLarger
              ? {
                  color: "white",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  "&:focus .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                }
              : {},
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
            sx: isViewportMediumOrLarger ? { color: "white" } : {},
          }}
        />
      )}
      sx={
        isViewportMediumOrLarger
          ? {
              color: "white",
              "& .MuiAutocomplete-option": {
                color: "black",
                "&:hover": { color: "white" },
              },
              "& .MuiAutocomplete-input": { color: "white" },
              "& .MuiSvgIcon-root": {
                color: "white",
                "&:hover": { color: "white" },
              },
            }
          : {}
      }
    />
  );
};
